<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="grid">
    <div class="grid-row">
        <div class="grid-row__cell">Name</div>
        <div class="grid-row__cell">Description</div>
        <div class="grid-row__cell">Quantity</div>
        <div class="grid-row__cell">List Price</div>
        <div class="grid-row__cell">Discount %</div>
        <div class="grid-row__cell">Amount</div>
    </div>

    <div *ngFor="let summaryRecord of recordsToShow" class="grid-row">
        <div [windeProductNameLink]="summaryRecord.record.name" class="grid-row__cell">{{ summaryRecord.record.name }}</div>
        <div class="grid-row__cell">{{ summaryRecord.record.description }}</div>
        <div class="grid-row__cell">{{ showInstalled ? summaryRecord.record.installedCount : summaryRecord.record.count }}</div>
        <div class="grid-row__cell">
            <winde-single-price-show [currency]="currencyCode" [price]="summaryRecord.record.listPrice"></winde-single-price-show>
        </div>
        <div class="grid-row__cell">
            <sui-number-component [config]="summaryRecord.discountControl"></sui-number-component>
        </div>
        <div class="grid-row__cell">
            <winde-single-price-show
                    [currency]="currencyCode"
                    [price]="showInstalled ? summaryRecord.record.installedCost : summaryRecord.record.cost"
            ></winde-single-price-show>
        </div>
    </div>
</div>
